import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
// import Button from '../components/Button';
import AboutImg from '../assets/images/me.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';
import ButtonCV from '../components/ButtonCV';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Olá, eu sou <span>Will Freittas</span>
              </p>
              <h2 className="about__heading"> Web developer</h2>
              <div className="about__info">
                <PText>
                  Eu sou de Belo Horizonte, Minas Gerais. Um lugar de beleza
                  ezuberante e natureza diversa. Desde a minha infância, eu amo
                  arte e design. Eu sempre tento projetar coisas com meu ponto
                  de vista único e adoro a ideia de criar coisas que podem ser
                  úteis para os outros.
                  <br /> <br />
                  Meu primeiro contato com a programação foi em 2016 com o VB6 e
                  desde então, foi algo que eu sempre quis muito fazer. A
                  codificação também é uma arte para mim. Adoro pensar que agora
                  tenho a oportunidade de desenhar e dar vida a minhas criações
                  através dos códigos. Eu amo todo o processo.
                  <br />
                  <br />
                  Minha visão é tornar o cotidiano das pessoas mais fácil e
                  dinâmico com o uso da tecnologia. Agora quase tudo está
                  ficando melhor do que nunca. Acredito fielmente que temos
                  condições de criarmos coisas magníficas que ajudem o mundo a
                  se tornar um lugar muito melhor e inclusivo.
                </PText>
              </div>

              <ButtonCV className="button" btnText="Download CV" />
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Educação</h1>

              <AboutInfoItem
                title="Básico"
                items={['EE José Luiz de Carvalho - Minas Gerais']}
              />
              <AboutInfoItem
                title="Colegial"
                items={['EE José Luiz de Carvalho - Minas Gerais']}
              />
              <AboutInfoItem
                title="Superior"
                items={['Uniube - Universidade de Uberaba - Minas Gerais']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Minhas Skills</h1>

              <AboutInfoItem
                title="FrontEnd"
                items={['HTML', 'CSS', 'JavaScript', 'REACT']}
              />
              <AboutInfoItem title="BackEnd" items={['Node', 'Express']} />
              <AboutInfoItem
                title="Design"
                items={['Photoshop', 'Adobe XD', 'Figma']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiências</h1>

              <AboutInfoItem
                title="2010-2020"
                items={['Técnico de informática']}
              />
              <AboutInfoItem
                title="2020 - 2022"
                items={['Início da Jornada Dev ']}
              />
              <AboutInfoItem
                title="2022-"
                items={['Desenvolvedor fullstack - BWM Technologie']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
